module.exports = __webpack_public_path__ + "Server-Unknown.AzureWebApp.1ae37377f947be98ad2012bbcaf7050f.hashedasset.svg";